import React from "react";
import { Typography, Box } from "@mui/material";

const Notice = ({type = 'warning', children, icon, style, sx}) => {

  const bg = {
    warning: "#F4FAF6",
    error: "#FFF2F2"
  }

  return (
    <Typography
      variant="formCaption"
      component="div"
      sx={{background: `${bg[type]}`, ...sx}}
      {...style}
      className="notice-field"
    >
      <Box>{icon && icon}</Box>
      <Box>
        {children}
      </Box>
    </Typography>
  );
};

export default Notice;
